import { type AxiosPromise } from "axios"
import httpModule from "../../../../utils/http"

export const getRatings = async (): Promise<AxiosPromise<any>> =>
  await httpModule.get(`/api/backoffice/v1/calificaciones `)
